import React from 'react';
import { TextField, Card, CardTitle, CardText, CardActions, Button } from 'react-md';
import { Avatar, Chip, SVGIcon } from 'react-md';
import {
  DataTable,
  TableHeader,
  TableBody,
  TableRow,
  TableColumn,
  TablePagination
} from 'react-md';

import moment from 'moment'
import backend from './../../../App/backend';


class TestRunList extends React.Component {
    constructor(props) {
            super(props);

            this.state = {
              projectId: props.projectId ? props.projectId : props.match.params.projectId,
              name: null,
              testRuns: null,
              testPlan: null,
              testRun: null,
              error1: null,
              isLoaded: false,
              isRunning: false
            };


        }

         componentDidMount() {
                this.fetchTestRuns();
                //clearInterval(this.interval);


               /* [1, 2, 3].map(n => n * 3);
                [1, 2, 3].reduce((total, n) => total + n);
                [1, 2, 3].filter(n => n <= 2);*/


              }

       componentWillUnmount() {
          clearInterval(this.interval);

            }

             fetchTestRuns() {
                       fetch(backend.url + '/projects/' + this.state.projectId + '/testRuns?sort=publicId,desc')
                         .then(res => res.json())
                         .then(
                           (result) => {
                             this.setState({
                               isLoaded: true,
                               testRuns: result
                             });
                             clearInterval(this.interval);
                              var notCompleted = result.filter(run => (run.status == 'AWAITING' || run.status == 'RUNNING')).length;
                              if(notCompleted !== 0){
                                //alert("notCompleted: " + notCompleted);
                                this.interval = setInterval(() => this.fetchTestRuns(), 2000)
                                //setTimeout(() => this.fetchTestRuns(), 5000);
                              }
                              //alert("this.interval: " + this.interval);
                           },
                           (error) => {
                             this.setState({
                               isLoaded: true,
                               error1: error
                             });
                           }
                         )
                     }

getDownloadLink(id) {
//http://localhost:8080/testRuns/4/downloadLog
return backend.url + '/testRuns/' + id + '/downloadLog';

}


   getYoutubeLikeToDisplay(millisec) {
        var seconds = (millisec / 1000).toFixed(0);
        var minutes = Math.floor(seconds / 60);
        var hours = "";
        if (minutes > 59) {
            hours = Math.floor(minutes / 60);
            //hours = (hours >= 10) ? hours : "0" + hours;
            minutes = minutes - (hours * 60);
            //minutes = (minutes >= 10) ? minutes : "0" + minutes;
        }

        seconds = Math.floor(seconds % 60);
        //seconds = (seconds >= 10) ? seconds : "0" + seconds;
        if (hours != "") {
            return hours + "h " + minutes + "m " + seconds + "s";
        }

        if (minutes != "") {
            return minutes + "m " + seconds + "s";
        }
        return seconds + "s";
    }

      stop(id) {
        //alert("id: " + id);

        fetch(backend.url + '/testRuns/' + id + '/exit')
           .then(res => res.json())
           .then(
             (result) => this.fetchTestRuns(),
             (error) => {
               this.setState({
                 isLoaded: true,
                 error1: error
               });
             }
           )
      }

    removeFromTheQueue(id) {
      //alert("id: " + id);

      fetch(backend.url + '/testRuns/' + id + '/cancel')
           .then(res => res.json())
           .then(
             (result) => this.fetchTestRuns(),
             (error) => {
               this.setState({
                 isLoaded: true,
                 error1: error
               });
             }
           )
    }

    createStatusButton(testRun) {
        //var id = testRun._links.self.href.split("/")[4];
        var id = testRun.id;
        if(testRun.status === 'AWAITING'){
            return  <Button flat primary swapTheming onClick={() => this.removeFromTheQueue(id)}>Remove from the queue</Button>;

        }else if(testRun.status === 'RUNNING'){
            return  <Button flat primary swapTheming onClick={() => this.stop(id)}>Stop</Button>;
        }
    }


render() {
var testRuns = null;
var error = null;//this.formatDate(item)
var started =  moment().format('MMMM Do YYYY, h:mm:ss a');
    if(this.state.isLoaded){
        if(this.state.testRuns){
            testRuns = this.state.testRuns.map((item, i) => (
                                <TableRow key={i}>
                                    <TableColumn>{ item.status }</TableColumn>
                                    <TableColumn>#{ item.publicId }</TableColumn>
                                    <TableColumn>
                                    {(item.status == 'SUCCESS' || item.status == 'EXIT_CODE') ? <a href={this.getDownloadLink(item.id)} target="_blank">Download Logs</a> : '' }
                                    </TableColumn>
                                    <TableColumn>{ item.testPlan.operatingSystem + '-' + item.testPlan.browser }</TableColumn>
                                    <TableColumn></TableColumn>
                                    <TableColumn>
                                        {item.startedAt ? moment(item.startedAt).format('DD/MM/YYYY, h:mm:ss a') : ''}
                                    </TableColumn>
                                    <TableColumn>{item.duration ? this.getYoutubeLikeToDisplay(item.duration) : this.createStatusButton(item)}</TableColumn>
                                  </TableRow>
                              ));
        }

        if(this.state.error1){
            error = this.state.error1.stack;
        }

    }



    return (
     <Card tableCard>
     <CardTitle title="Test Runs"/>
 <DataTable plain>
     <TableHeader>
       <TableRow>
         <TableColumn>Status</TableColumn>
         <TableColumn>Run</TableColumn>
         <TableColumn>Artifacts</TableColumn>
         <TableColumn>Run Configuration</TableColumn>
         <TableColumn>Message</TableColumn>
         <TableColumn>Started</TableColumn>
         <TableColumn>Duration</TableColumn>
       </TableRow>
     </TableHeader>
     <TableBody>
       { testRuns }
       { error }
     </TableBody>
   </DataTable>
   </Card>
);
}
}

export default TestRunList;



// WEBPACK FOOTER //
// ./src/containers/Project/Detail/TestRun/List.js